// react
import React, { Component } from 'react';

// third-party
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { FormattedMessage } from 'react-intl';

// data stubs
import orderApi from '../../server/real/endpoints/orders';
import ProgramContext from '../../contexts/ProgramContext';

export default class AccountPageOrders extends Component {
    constructor(props) {
        super(props);

        this.state = {
            orders: [],
        };
    }

    componentDidMount = () => {
        orderApi.getOrders().then((ordersData) => {
            this.setState({ orders: ordersData.data });
        });
    }

    render() {
        const { orders } = this.state;

        const ordersList = orders.map((order) => (
            <tr key={order.id}>
                <td>
                    <Link to={`/account/orders/${order.id}`}>
                        #
                        {order.orderNumber}
                    </Link>
                </td>
                <td>
                    {new Date(order.date).toLocaleString('en-US', {
                    weekday: 'short', // long, short, narrow
                    day: 'numeric', // numeric, 2-digit
                    year: 'numeric', // numeric, 2-digit
                    month: 'long', // numeric, 2-digit, long, short, narrow
                })}
                </td>
                <td>{order.status === 'Shipped' ? <a href={order.items[0].tracking.trackingLink} target="_blank" rel="noreferrer">{order.status}</a> : <React.Fragment>{order.status === 'API Error' ? 'Pending' : order.status}</React.Fragment>}</td>
                <ProgramContext.Consumer>
                    {(context) => {
                                        const { program } = context;
                                        return (
                                            program && program.type === 'points'
                                            && (
                                            <td>{order.total}</td>
                )
                                       );
                                    }}
                </ProgramContext.Consumer>
            </tr>
        ));

        return (
            <div className="card">
                <ProgramContext.Consumer>
                    {(context) => {
                        const { program } = context;
                        return (
                            <Helmet>
                                <title>{`Order History — ${program.fullName}`}</title>
                            </Helmet>
                        );
                    }}
                </ProgramContext.Consumer>

                <div className="card-header">
                    <h5>Order History</h5>
                </div>
                <div className="card-divider" />
                <div className="card-table">
                    <div className="table-responsive-sm">
                        <table>
                            <thead>
                                <tr>
                                    <th>
                                        <FormattedMessage id="account_dashorder" defaultMessage="Order" />
                                    </th>
                                    <th>
                                        <FormattedMessage id="account_dashdate" defaultMessage="Date" />
                                    </th>
                                    <th>
                                        <FormattedMessage id="account_dashstatus" defaultMessage="Status" />
                                    </th>
                                    <ProgramContext.Consumer>
                                        {(context) => {
                                        const { program } = context;
                                        return (
                                            program && program.type === 'points'
                                            && (
                                            <th>
                                                <FormattedMessage id="account_dashtotal" defaultMessage="Total" />
                                            </th>
)
                                       );
                                    }}
                                    </ProgramContext.Consumer>
                                </tr>
                            </thead>
                            <tbody>
                                {ordersList}
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className="card-divider" />
            </div>
        );
    }
}
